export const softValidate = (files: File[], accept: string, minSizeBytes?: number, maxSizeBytes?: number) => {
  const rules = parseAccept(accept);
  const ok: File[] = [];

  for (const f of files) {
    if (minSizeBytes != null && f.size < minSizeBytes) {
      continue;
    }
    if (maxSizeBytes != null && f.size > maxSizeBytes) {
      continue;
    }
    if (rules.length && !matchesAccept(f, rules)) {
      continue;
    }
    ok.push(f);
  }

  return ok;
};

type Rule =
  | { kind: 'ext'; ext: string } // ".mp3"
  | { kind: 'mime'; type: string; subtype: string } // "audio/mpeg"
  | { kind: 'wild'; type: string }; // "audio/*"

function parseAccept(accept?: string): Rule[] {
  if (!accept) {
    return [];
  }
  return accept
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean)
    .map<Rule | null>((tok) => {
      if (tok.startsWith('.')) {
        return { kind: 'ext', ext: tok.slice(1) };
      }
      const slash = tok.indexOf('/');
      if (slash > 0) {
        const type = tok.slice(0, slash);
        const subtype = tok.slice(slash + 1);
        if (!type || !subtype) {
          return null;
        }
        if (subtype === '*') {
          return { kind: 'wild', type };
        }
        return { kind: 'mime', type, subtype };
      }
      return null;
    })
    .filter((r): r is Rule => r !== null);
}

function matchesAccept(file: File, rules: Rule[]): boolean {
  const mime = (file.type || '').toLowerCase();
  const name = (file.name || '').toLowerCase();
  const dot = name.lastIndexOf('.');
  const ext = dot >= 0 ? name.slice(dot + 1) : '';

  for (const r of rules) {
    if (r.kind === 'ext') {
      if (ext && ext === r.ext) {
        return true;
      }
    } else if (r.kind === 'mime') {
      if (mime && mime === `${r.type}/${r.subtype}`) {
        return true;
      }
    } else if (r.kind === 'wild') {
      if (mime?.startsWith(`${r.type}/`)) {
        return true;
      }
    }
  }
  return false;
}
